export const calculateFuelCost = (
  variant: { fuelType: string; mileage: string; fuelRate: string, batteryCapacity?: string },
  dailyDistance: number
): string => {
  const currentFuelPrice = parseFloat(variant.fuelRate);

  const mileage = parseFloat(variant.mileage);
  const distancePerMonth = dailyDistance * 30;

  if (mileage === 0) {
    return "N/A";
  }

  if (variant.fuelType.toLowerCase() === "electric") {
    const batteryCapacity = variant.batteryCapacity ? parseFloat(variant.batteryCapacity)/1000 : 0;
    const cost = distancePerMonth * currentFuelPrice * (batteryCapacity / mileage);
    return Math.round(cost).toLocaleString('en-IN');
  }

  const cost = (distancePerMonth / mileage) * currentFuelPrice;
  return Math.round(cost).toLocaleString('en-IN');
};